module.exports = __webpack_public_path__ + "static/media/performance-interaction.03b42420.gif";